import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NumericValueAccessorDirective } from '@skylab-angular-shared/ui';
import { ChosenColumn } from '../printing-pattern-dialog.component';

@Component({
    selector: 'skl-printing-pattern-dialog-grid-width',
    template: `
    <ins-form-field
        class="no-boundary grid-cell-ins-component">
        <ins-input
            inputmode="decimal"
            [(ngModel)]="entity.width"
            [precision]="2">
        </ins-input>
    </ins-form-field>`,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [NumericValueAccessorDirective, FormsModule]
})
export class PrintingPatternDialogGridWidth {
    @Input() public entity!: ChosenColumn;
}
